<template>
	<div>
		<span class="icon is-small">
			<i class="fas fa-calendar-alt fa"></i>
		</span>
		<span class="text">{{dateFormat}}</span>
		<span class="icon is-small">
			<i class="fas fa-clock fa"></i>
		</span>
		<span class="text">{{timeFormat}}</span>
	</div>
</template>

<script>
var moment = require('moment')
export default {
	props: {
		value: ''
	},
	computed: {
		dateFormat() {
			return moment(this.value).format('DD.MM.YYYY')
		},
		timeFormat() {
			return moment(this.value).format('HH:mm')
		}
	},
	mounted() {
		// console.log('sdfsdf')
	}
}
</script>
<style scoped>
.icon {
	vertical-align: middle;
	color: #888;
	margin-left: 10px;
}
.text {
	vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// FDateTime.vue?f2717198